import React, { useContext } from 'react';

import I18nContext from '../../../aurr/contexts/I18nContext';
import IconMyClasses from '../../../icons/IconMyClasses';
import IconPlaylist from '../../../icons/IconPlaylist';

export function AUDefaultContent({
  type = 'playlists',
}: {
  type?: 'playlists' | 'bookmarks' | 'my-classes';
}) {
  const { Trans } = useContext(I18nContext);

  return (
    <div className="au-w-full au-py-c100 au-flex au-text-center au-justify-center au-items-center">
      <div className="au-max-w-c520">
        <div className="au-relative au-w-c80 au-h-c80 au-rounded-full au-bg-gray-e5 au-mb-c20 au-mx-auto au-text-center au-flex au-items-center au-justify-center">
          {type === 'playlists' && <IconPlaylist width={40} height={40} />}
          {(type === 'bookmarks' || type === 'my-classes') && (
            <IconMyClasses width={40} height={40} />
          )}
        </div>
        <p className="au-text-white au-mb-c20 au-text-c16 au-leading-c22 au-font-bold">
          {type === 'playlists' && (
            <Trans i18nKey="playlists.no_playlists_title" ns="common">
              {/* eslint-disable-next-line react/no-unescaped-entities */}
              Looks like you haven't curated any playlists yet
            </Trans>
          )}
          {type === 'bookmarks' && (
            <Trans i18nKey="bookmarks.no_bookmarks_title" ns="common" />
          )}
          {type === 'my-classes' && (
            <Trans i18nKey="myClasses.no_classes_title" ns="common" />
          )}
        </p>
        <p className="au-text-white au-mb-c20 au-text-c12 au-leading-c24 au-font-regular">
          {type === 'playlists' && (
            <Trans i18nKey="playlists.no_playlists_body" ns="common">
              Playlists are a great way to curate classes and articles. <br />
              Playlists can be shared with friends, colleagues and team members.
              <br />
              <br />
              Look for the Playlists icon{' '}
              <IconPlaylist
                className="au-inline"
                width={12}
                height={12}
                fill="white"
              />{' '}
              on class and article pages and start curating today!
            </Trans>
          )}
          {type === 'bookmarks' && (
            <Trans i18nKey="bookmarks.no_bookmarks_body" ns="common" />
          )}
          {type === 'my-classes' && (
            <Trans i18nKey="myClasses.no_classes_body" ns="common" />
          )}
        </p>
      </div>
    </div>
  );
}
